import moment from "moment";

export function isValidCertificate(vencimento: string | undefined): boolean {
  if (!vencimento) return false;

  // Detecta automaticamente o formato da data
  let momentDate: moment.Moment;

  // Verifica se é um formato ISO
  if (vencimento.includes("T") || vencimento.includes("Z")) {
    momentDate = moment(vencimento);
  } 
  // Verifica se é um formato brasileiro (DD/MM/YYYY HH:mm:ss)
  else if (vencimento.includes("/") && vencimento.includes(":")) {
    momentDate = moment(vencimento, "DD/MM/YYYY HH:mm:ss", true); // 'true' faz o strict parsing
  } 
  // Caso o formato seja possivelmente americano, tenta o formato americano (MM/DD/YYYY)
  else if (vencimento.includes("/")) {
    momentDate = moment(vencimento, "MM/DD/YYYY", true);
  } 
  // Tenta parsing automático
  else {
    momentDate = moment(vencimento);
  }

  // Verifica se a data é válida e se é após a data atual
  return momentDate.isValid() && momentDate.isAfter(moment.now());
}


export function formatCertificateDate(vencimento: string | undefined): string {
  if (!vencimento) return "";

  // Detecta automaticamente o formato da data
  let momentDate: moment.Moment;

  if (vencimento.includes("T") || vencimento.includes("Z")) {
    // Formato ISO (2028-02-03T12:00:00.000Z)
    momentDate = moment(vencimento);
  } else if (vencimento.includes("/") && vencimento.includes(":")) {
    // Formato brasileiro (19/09/2026 14:57:29)
    momentDate = moment(vencimento, "DD/MM/YYYY HH:mm:ss", true); // 'true' para strict parsing
  } else if (vencimento.includes("/")) {
    // Formato americano (MM/DD/YYYY), tenta o parsing estrito
    momentDate = moment(vencimento, "MM/DD/YYYY", true);
  } else {
    // Tenta parsing automático
    momentDate = moment(vencimento);
  }

  // Verifica se a data é válida e formata
  return momentDate.isValid()
    ? momentDate.format("DD/MM/YYYY HH:mm:ss")
    : vencimento;
}


export function getCertificateValidationMessage(
  vencimento: string | undefined
): string {
  if (!vencimento) {
    return "Certificado digital não encontrado. É necessário enviar um certificado válido para emitir notas fiscais.";
  }

  if (!isValidCertificate(vencimento)) {
    const formattedDate = formatCertificateDate(vencimento);
    return `Certificado digital expirado. Venceu em ${formattedDate}. É necessário enviar um certificado válido para emitir notas fiscais.`;
  }

  return "";
}
